/* global console */

import * as React from "react";
import { useState } from "react";
import { FlatTree, FlatTreeItem, TreeItemLayout, TreeItemValue } from "@fluentui/react-components";
import { Icon } from "@fluentui/react";
import useVirtualTree, { VirtualTreeProps } from "./VirtualTreeHook";
import { DocumentRoot } from "../../../api/models/document-root";
import { generateIdentifier } from "../../../utils/helpers/RobotFramework";
import { DownloadDocumentButton } from "../DownloadDocumentButton";
import { useHandleLoaderForDownloadCopy } from "../../../pages/document/DownloadCopyPage/useHandleLoaderForDownloadCopy";
import { Tooltip } from "../../cpm/DocumentPartTree";

interface MouseOverState {
  tooltipPath: string;
  hoveredItem: TreeItemValue | null;
  tooltipPosition?: { positionX: number; positionY: number };
}

const FOLDER_CREATION = "/drive/root:";

export const VirtualTree = (props: VirtualTreeProps) => {
  useHandleLoaderForDownloadCopy();

  const { flatTree, selectedItem, handleScroll, styles, handleClick, itemToFocusValue, itemToFocusRef, FlatTreeRef } =
    useVirtualTree(props);

  const [state, setState] = useState<MouseOverState>({
    tooltipPath: "",
    hoveredItem: null,
    tooltipPosition: null,
  });

  const getPathForFileLocationExplorer = (path: string) => {
    return path?.replace(FOLDER_CREATION, "Shared Documents");
  };

  const handleMouseOver = (event: React.MouseEvent<HTMLDivElement>, documentRoot: TreeItemValue) => {
    console.log("Mouse over on item:", event);
    const thisItem = props.childrenItems.find((i) => i.document.driveItemId === documentRoot);
    if (thisItem) {
      setState({
        tooltipPath: getPathForFileLocationExplorer(thisItem.document.path),
        hoveredItem: documentRoot,
        tooltipPosition: { positionX: event.clientX, positionY: event.clientY },
      });
    }
  };

  const handleMouseOut = () => {
    setState((prev) => ({
      ...prev,
      tooltipPath: "",
      tooltipVisible: false,
      hoveredItem: null,
    }));
  };

  return (
    <>
      <FlatTree
        {...flatTree.getTreeProps()}
        aria-label="Virtual Tree"
        onScroll={(e) => {
          handleScroll(e);
          handleMouseOut();
        }}
        className={styles.container}
        ref={FlatTreeRef}
      >
        {Array.from(flatTree.items(), (flatTreeItem) => {
          const { value, name, document, permission, ...treeItemProps } = flatTreeItem.getTreeItemProps();
          const documentRoot: DocumentRoot = { documentPart: document, hasReadPermissions: permission };

          return (
            <div
              className={permission ? styles.rowTreeItemBlack : styles.rowTreeItemGray}
              style={
                selectedItem?.key === flatTreeItem.value
                  ? { backgroundColor: "rgb(237, 235, 233)", position: "relative" }
                  : { position: "relative" }
              }
              key={value}
            >
              <Icon className={styles.fileIconHeaderIcon} iconName={"WordLogoInverse"} />
              <FlatTreeItem
                onClick={() => handleClick(documentRoot)}
                {...treeItemProps}
                id={generateIdentifier(name.toString(), "treeitem")}
                value={value}
                ref={value === itemToFocusValue ? itemToFocusRef : undefined}
                onMouseOver={(event) => handleMouseOver(event, value)}
                onMouseOut={handleMouseOut}
              >
                <TreeItemLayout className={styles.documentName}>
                  {value !== "more" ? name : <span onClick={() => console.log("Load more", name)}>{name}</span>}
                  {state.tooltipPosition && state.hoveredItem === value && (
                    <Tooltip positionY={state.tooltipPosition.positionY} positionX={state.tooltipPosition.positionX}>
                      {state.tooltipPath}
                    </Tooltip>
                  )}
                </TreeItemLayout>
              </FlatTreeItem>
              {props.showDownloadButton && permission && <DownloadDocumentButton document={document} />}
            </div>
          );
        })}
      </FlatTree>
    </>
  );
};
